<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.latentStudentList.push"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <v-column-time value="注册时间"/>
    <v-column-student/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="注册来源">
      <template v-slot="{ row }">
        {{ row.store_name || '小程序' }}
      </template>
    </el-table-column>
    <el-table-column label="操作" width="244px">
      <template v-slot="{ row }">
        <v-list-button :to="studentEditTo(row.id, { is_from_latent: 1 })"/>
        <v-list-button name="注销" icon="bin" :to="studentDeleteDetailTo(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>姓名</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>注册时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>注册来源</span>
              <span>{{ v.store_name || '小程序' }}</span>
            </div>
            <div class="list-item-detail">
              <span>身份证号</span>
              <span>{{ v.id_number }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="studentEditTo(v.id, { is_from_latent: 1 })"/>
              <v-list-button name="注销" icon="bin" :to="studentDeleteDetailTo(v.id)"/>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/student';

export default {
  name: RouteConfig.latentStudentList.name,
  data: () => ({
    RouteConfig,
    studentEditTo: RouteConfig.studentEdit.to,
    studentDeleteDetailTo: RouteConfig.studentDeleteDetail.to,
    isLoading: false,
    isShowDialog: false,
    isSavingIds: [],
    isSettingIds: [],
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    currentStudentId: 0,
    teacher: {
      teacher_id: 0,
    },
  }),
  computed: {
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.latentStudentList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      queryList.is_latent = 1;
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>

<style src="./index.css" scoped/>
